/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["@import url(https://fonts.googleapis.com/css?family=Open+Sans:400,600,700,800&display=swap);.link[_ngcontent-%COMP%]{color:#3f8978}.link__item[_ngcontent-%COMP%]{cursor:pointer}.link__item[_ngcontent-%COMP%]:hover{text-decoration:underline}"];
export { styles as styles };
